/* GENERATED FILE - do not edit. Run: node scripts/generate-phosphor-icons.mjs */
import type { JSX } from 'solid-js'
import { IconBase, type IconProps, type WeightRenderers } from './IconBase'

const renderers: WeightRenderers = {
  regular: (color: string): JSX.Element => (
    <g>
      <line
        x1="40"
        y1="128"
        x2="216"
        y2="128"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
    </g>
  ),
  bold: (color: string): JSX.Element => (
    <g>
      <line
        x1="40"
        y1="128"
        x2="216"
        y2="128"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      />
    </g>
  ),
}

export const Minus = (props: IconProps) => <IconBase {...props} renderers={renderers} />
